import PropTypes from 'prop-types';

import Banner from '../Banner/Banner';
import Slider from '../Slider/Slider';
import styles from './Content.module.css';
import ContentItem from './ContentItem/ContentItem';
// import useContent from "./useContent";

const Content = ({ layouts, className }) => {
  const items = layouts
    .sort((a, b) => b.priority - a.priority)
    .map((content, contentIndex) => {
      let SlidersBanners = null;
      const Banners = content.banners;
      const Sliders = content.sliders;
      if (Banners && Sliders) {
        SlidersBanners = Sliders.concat(Banners);
      }

      return SlidersBanners ? (
        <ContentItem key={contentIndex} data={content}>
          {SlidersBanners.sort((a, b) => b.priority - a.priority).map((contentItem) => {
            const ContentComponent = 'products' in contentItem ? Slider : Banner;
            return <ContentComponent key={contentItem.id} data={contentItem} />;
          })}
        </ContentItem>
      ) : null;
    });

  return <div className={`${styles.MainPage} ${className || ''}`}>{items}</div>;
};

Content.propTypes = {
  layouts: PropTypes.object
};

export default Content;
